import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import {AzPageHeader} from '../../components/AzPageHeader'
import { ReservationsListWrapper } from './reservation-list/ReservationList';
import { useIntl } from 'react-intl';

const ReservationPage = () => {
  const intl = useIntl();

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='reservations'
          element={
            <>
              <AzPageHeader title={intl.formatMessage({ id: 'RESERVATION_PAGE.TITLE' })} />
              <ReservationsListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/reservation-management/reservations' />} />
    </Routes>
  );
};

export default ReservationPage;